import React, { PropsWithChildren } from "react";

import { defaultQueryClient } from "@steto-care/steto-query";
import { QueryClientProvider } from "@tanstack/react-query";

/**
 * Query client only: the QueryAwait boundary lives below LoginBouncer, so a
 * suspending or failing query can't replace the login page with a fallback.
 */
export const QueriesWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={defaultQueryClient}>{children}</QueryClientProvider>;
};
